module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    attrs: {
      "border": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', [_vm._v("loaded:  " + _vm._s(_vm.loaded))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-116246cd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomUser.vue
// module id = 306
// module chunks = 2